import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheet from "../pages/kakobuy-spreadsheet/page";
import KakobuyGuide from "../pages/kakobuy-guide/page";
import CoToJestKakobuySpreadsheet from "../pages/co-to-jest-kakobuy-spreadsheet/page";
import NajlepszyKakobuySpreadsheet from "../pages/najlepszy-kakobuy-spreadsheet/page";
import DarmowySpreadsheet from "../pages/darmowy-spreadsheet/page";
import JakKupowacPrzezKakobuy from "../pages/jak-kupowac-przez-kakobuy/page";
import PoradnikDlaPoczatkujacych from "../pages/poradnik-dla-poczatkujacych/page";
import CoToJestQC from "../pages/co-to-jest-qc/page";
import JakSprawdzacQC from "../pages/jak-sprawdzac-qc/page";
import CzyKakobuyJestBezpieczny from "../pages/czy-kakobuy-jest-bezpieczny/page";
import KosztyWysylki from "../pages/koszty-wysylki/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuySpreadsheet />,
  },
  {
    path: "/kakobuy-guide",
    element: <KakobuyGuide />,
  },
  {
    path: "/co-to-jest-kakobuy-spreadsheet",
    element: <CoToJestKakobuySpreadsheet />,
  },
  {
    path: "/najlepszy-kakobuy-spreadsheet",
    element: <NajlepszyKakobuySpreadsheet />,
  },
  {
    path: "/darmowy-spreadsheet",
    element: <DarmowySpreadsheet />,
  },
  {
    path: "/jak-kupowac-przez-kakobuy",
    element: <JakKupowacPrzezKakobuy />,
  },
  {
    path: "/poradnik-dla-poczatkujacych",
    element: <PoradnikDlaPoczatkujacych />,
  },
  {
    path: "/co-to-jest-qc",
    element: <CoToJestQC />,
  },
  {
    path: "/jak-sprawdzac-qc",
    element: <JakSprawdzacQC />,
  },
  {
    path: "/czy-kakobuy-jest-bezpieczny",
    element: <CzyKakobuyJestBezpieczny />,
  },
  {
    path: "/koszty-wysylki",
    element: <KosztyWysylki />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;